import { createSlice } from "@reduxjs/toolkit";
import { filterOrderByMilestone, sortAllView } from "../utils";

const defaultViewForCurrent = {
  column_width_for_default: {},
  isShowBoardView: false,
  boardView: { value: "Default View", sub_type: "status" },
  listView: { value: "Default View", sub_type: null },
};

const initialState = {
  boardView: "false",
  allViews: {
    listView: {
      nameOfViews: [],
      allItemsName: [
        "NAME",
        "ACTIONS",
        "STATUS",
        "SUPPLIER",
        "FROM FACILITY",
        "TO FACILITY",
        "PURCHASE ORDERS",
        "TRANSFER ORDERS",
        "ORDER DATE",
        "ETA",
        "TRACKER",
        "CREATED BY",
      ],
      allViews: {
        "Default View": [
          "NAME",
          "ACTIONS",
          "STATUS",
          "SUPPLIER",
          "FROM FACILITY",
          "TO FACILITY",
          "PURCHASE ORDERS",
          "TRANSFER ORDERS",
          "ORDER DATE",
          "ETA",
          "TRACKER",
          "CREATED BY",
        ],
      },
    },
    boardView: {
      status: {
        nameOfViews: [],
        allItemsName: [],
        allViews: {
          "Default View": [],
        },
      },
      milestone: {
        nameOfViews: [],
        allItemsName: [],
        allViews: {},
      },
      combined: {
        nameOfViews: [],
        allItemsName: [],
        allViews: {},
      },
    },
  },

  singleView: {},
  milestoneOrders: {},
  milestoneList: [],
  filterShipmentByMilestone: {},
  consignmentMappedById: {},

  allFilterField: [],
  allFilterCondition: [],
  filteredConsignmentByRule: { count: 0, results: [] },
  statusForFilter: [],
  currentView: {
    purchase: {
      column_width_for_default: {},
      isShowBoardView: false,
      boardView: { value: "Default View", sub_type: "status" },
      listView: { value: "Default View", sub_type: null },
    },
    receipt: defaultViewForCurrent,
    product: defaultViewForCurrent,
    productCategory: defaultViewForCurrent,
    productTag: defaultViewForCurrent,
    productAlias: defaultViewForCurrent,
    warehouse: defaultViewForCurrent,
    supplier: defaultViewForCurrent,
    pack: defaultViewForCurrent,
    warehouseCostingRange: defaultViewForCurrent,
    stockZone: defaultViewForCurrent,
    forecast: defaultViewForCurrent,
    stockLocation: defaultViewForCurrent,
    standardCost: defaultViewForCurrent,
    warehouseCosting: defaultViewForCurrent,
    productPlan: defaultViewForCurrent,
    transactionReason: defaultViewForCurrent,
    chartsOfAccount: defaultViewForCurrent,
    paymentTerm: defaultViewForCurrent,
    journalLine: defaultViewForCurrent,
    bill: defaultViewForCurrent,
    billChargeType: defaultViewForCurrent,
    receiptAdjustment: defaultViewForCurrent,
    taxRate: defaultViewForCurrent,
    syncHistory: defaultViewForCurrent,
    shopifyStores: defaultViewForCurrent,
    shopifyCatalogue: defaultViewForCurrent,
    shopifyLinkedProducts: defaultViewForCurrent,
    supplierCreditNote: defaultViewForCurrent,
    customerCreditNote: defaultViewForCurrent,
    prePayment: defaultViewForCurrent,
    stockReplenishment: defaultViewForCurrent,
    plannedOrder: defaultViewForCurrent,
    customer: defaultViewForCurrent,
    taxCategory: defaultViewForCurrent,
    unitOfMeasure: defaultViewForCurrent,
    equipmentType: defaultViewForCurrent,
    productTaxClassification: defaultViewForCurrent,
    salesRep: defaultViewForCurrent,
    users: defaultViewForCurrent,
    quote: defaultViewForCurrent,
    salesOrder: defaultViewForCurrent,
    customerTag: defaultViewForCurrent,
    equipment: defaultViewForCurrent,
    picklist: defaultViewForCurrent,
    promo: defaultViewForCurrent,
    stockPack: defaultViewForCurrent,
    saleInvoice: defaultViewForCurrent,
    customerSegment: defaultViewForCurrent,
    pricelist: defaultViewForCurrent,
    delivery: defaultViewForCurrent,
    shipmentV1: defaultViewForCurrent,
    asn: defaultViewForCurrent,
    shipmentLeg: defaultViewForCurrent,
    workCenter: defaultViewForCurrent,
    people: defaultViewForCurrent,
    site: defaultViewForCurrent,
    boms: defaultViewForCurrent,
    manufacturingOrder: defaultViewForCurrent,
    coManufacturingOrder: defaultViewForCurrent,
    consignment: {
      column_width_for_default: {},
      isShowBoardView: true,
      boardView: { value: "Default View", sub_type: "status" },
      listView: { value: "Default View", sub_type: null },
    },
    transfer: {
      column_width_for_default: {},
      isShowBoardView: false,
      boardView: { value: "Default View", sub_type: "status" },
      listView: { value: "Default View", sub_type: null },
    },
    allocation: {
      purchase: defaultViewForCurrent,
      transfer: defaultViewForCurrent,
      salesOrder: defaultViewForCurrent,
      manufacturingOrder: defaultViewForCurrent,
      allocationType: "purchase",
    },
    inventory: {
      inventory: defaultViewForCurrent,
      inventoryDetail: defaultViewForCurrent,
      inventoryTransactions: defaultViewForCurrent,
    },
  },
  currentPageViewDetails: {
    purchase: null,
    consignment: null,
    consignment_file: null,
    transfer: null,
    stock_replenishment: null,
  },
  detailsPage: {
    columnForDetails: {
      purchase: null,
      consignment: null,
      transfer: null,
      stock_replenishment: null,
    },
    columnWidthForDetails: {},
  },
};

const newInterfaceSlice = createSlice({
  name: "newInterface",
  initialState,
  reducers: {
    setMilestoneOrders: (state, action) => {
      state.milestoneList = action.payload;
    },
    handleAllViews: (state, action) => {
      const { nameOfView, listViews } = action.payload;
      if (nameOfView) {
        if (nameOfView === "forAll") {
          state.allViews = listViews;
        } else {
          state.allViews = {
            ...state.allViews,
            [nameOfView]: listViews,
          };
        }
      }

      localStorage.setItem("allViews", JSON.stringify(state.allViews));
    },
    handleMilestoneOrders: (state, action) => {
      const { currentView, listOfMilestoneorders } = action.payload;
      state.milestoneOrders = {
        ...state.milestoneOrders,
        [currentView]: listOfMilestoneorders,
      };
    },
    setAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.allViews = {
        listView: {
          ...state.allViews.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.allViews.listView.allViews, ...views.list.allViews },
        },
        boardView: {
          status: {
            ...state.allViews.boardView.status,
            nameOfViews: views.status.nameOfList,
            allViews: { ...state.allViews.boardView.status.allViews, ...views.status.allViews },
          },
          milestone: {
            nameOfViews: views.milestone.nameOfList,
            allViews: views.milestone.allViews,
          },
          combined: {
            nameOfViews: views.combined.nameOfList,
            allViews: views.combined.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setSingleView: (state, action) => {
      state.singleView = action.payload;
    },
    handleFilterShipmentByMilestone: (state, action) => {
      const { filterd, mapConsignments } = filterOrderByMilestone(
        action.payload,
        state.milestoneList,
      );
      state.consignmentMappedById = mapConsignments;
      state.filterShipmentByMilestone = filterd;
    },
    updateFilterShipmentByMilestone: (state, action) => {
      const filterd = { ...state.filterShipmentByMilestone };

      filterd[action.payload.sourceIndex] = filterd[action.payload.sourceIndex].filter(
        item => item !== action.payload.data.ids[0],
      );
      filterd[action.payload.id] = [...action.payload.data.ids, ...filterd[action.payload.id]];

      state.filterShipmentByMilestone = filterd;
    },
    setAllFilterCondition: (state, action) => {
      state.allFilterCondition = action.payload;
    },
    setAllFilterField: (state, action) => {
      state.allFilterField = action.payload;
    },
    setConsignmentsForRule: (state, action) => {
      const { results, count } = action.payload;
      state.filteredConsignmentByRule = { results, count };
    },
    setViewAndDetailsColumns: (state, action) => {
      if (!action.payload) return;
      const { view, column_for_detail, column_for_detail_width } = action.payload;
      state.currentPageViewDetails = { ...state.currentPageViewDetails, ...view };
      state.detailsPage = {
        columnForDetails: column_for_detail,
        columnWidthForDetails: column_for_detail_width,
      };
    },
    setColumnWidthForDefaultViewInLocals: (state, action) => {
      const { module, allocation, column_width } = action.payload;
      let views = {
        ...state.currentView,
      };
      if (allocation) {
        if (!views["allocation"][allocation]["column_width_for_default"])
          views["allocation"][allocation]["column_width_for_default"] = {};

        views["allocation"][allocation]["column_width_for_default"][column_width["column_name"]] =
          column_width.width;
      } else if (
        module === "inventory" ||
        module === "inventoryDetail" ||
        module === "inventoryTransactions"
      ) {
        if (!views["inventory"][module]["column_width_for_default"])
          views["inventory"][module]["column_width_for_default"] = {};

        views["inventory"][module]["column_width_for_default"][column_width["column_name"]] =
          column_width.width;
      } else {
        if (!views[module]["column_width_for_default"])
          views[module]["column_width_for_default"] = {};

        views[module]["column_width_for_default"][column_width["column_name"]] = column_width.width;
      }

      localStorage.setItem("currentView", JSON.stringify(views));
      state.currentView = views;
    },
    setCurrentViewInLocals: (state, action) => {
      const { module, view, allocation } = action.payload;
      let views = {
        ...state.currentView,
      };
      if (allocation) {
        views["allocation"] = {
          ...views.allocation,
          [allocation]: {
            ...state.currentView["allocation"][allocation],
            isShowBoardView: false,
            listView: view,
          },
        };
      } else if (
        module === "inventory" ||
        module === "inventoryDetail" ||
        module === "inventoryTransactions"
      ) {
        views["inventory"] = {
          ...views.inventory,
          [module]: {
            ...state.currentView["inventory"][module],
            isShowBoardView: false,
            listView: view,
          },
        };
      } else {
        views[module] = {
          ...state.currentView[module],
          isShowBoardView: view.sub_type ? true : false,
          [view.sub_type ? "boardView" : "listView"]: view,
        };
      }
      localStorage.setItem("currentView", JSON.stringify(views));
      state.currentView = views;
    },
    getCurrentViewFromLocals: (state, action) => {
      const views = JSON.parse(localStorage.getItem("currentView"));
      if (views) {
        // Deep-merge allocation to preserve any new keys added to initialState
        if (views.allocation) {
          views.allocation = {
            ...state.currentView.allocation, // initialState shape (has salesOrder)
            ...views.allocation, // user's saved overrides
          };
        }
        // Add: ensure new module keys from initialState are preserved
        state.currentView = { ...state.currentView, ...views };
      } else {
        localStorage.setItem("currentView", JSON.stringify(state.currentView));
      }
    },
    setStatusForRule: (state, action) => {
      state.statusForFilter = action.payload;
    },
    setListOfStatusForDefaultView: (state, action) => {
      state.allViews.boardView.status.allViews["Default View"] = action.payload;
    },
    setAlloctionType: (state, action) => {
      const views = { ...state.currentView };
      views.allocation.allocationType = action.payload;

      localStorage.setItem("currentView", JSON.stringify(state.currentView));
    },
  },
});

export const {
  setMilestoneOrders,
  handleAllViews,
  handleMilestoneOrders,
  setAllViews,
  setSingleView,
  handleFilterShipmentByMilestone,
  updateFilterShipmentByMilestone,
  setAllFilterCondition,
  setAllFilterField,
  setConsignmentsForRule,
  setViewAndDetailsColumns,
  setCurrentViewInLocals,
  getCurrentViewFromLocals,
  setStatusForRule,
  setListOfStatusForDefaultView,
  setColumnWidthForDefaultViewInLocals,
  setAlloctionType,
} = newInterfaceSlice.actions;

export default newInterfaceSlice.reducer;
